import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { TaggingAdminComponent } from './tagging-admin.component';

const routes: Routes = [
  { path: '', component: TaggingAdminComponent, data: { title: 'Tagging Administration' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TaggingAdminRoutingModule {}

@NgModule({
  imports: [
    TaggingAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [TaggingAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TaggingAdminModule {}
